import ContactForm from '@/components/ContactForm';
import { Mail, MapPin } from 'lucide-react';

export default function Contact() {
  return (
    <div className="page-shell">
      <div className="max-w-3xl">
        <h1 className="section-heading">Contact Us</h1>
        <p className="section-subheading">
          Looking for a boutique software partner? Tell us about your project and we&apos;ll get
          back to you personally.
        </p>
      </div>

      <div className="mt-10 grid gap-10 lg:mt-12 lg:grid-cols-5 lg:gap-12">
        <div className="space-y-8 lg:col-span-2">
          <div>
            <h2 className="text-xl font-bold text-brand-900 sm:text-2xl">Get in touch</h2>
            <p className="mt-2 text-base font-semibold text-slate-600 sm:text-lg">
              Share a few details and we&apos;ll review your enquiry — typically within one
              business day.
            </p>
          </div>

          <ul className="space-y-5 text-base font-semibold text-slate-600 sm:text-lg">
            <li className="flex gap-3">
              <Mail className="mt-0.5 h-5 w-5 shrink-0 text-brand-600" />
              <div className="min-w-0">
                <p className="font-bold text-slate-800">Website</p>
                <a
                  href="https://www.adsperianx.com.my"
                  className="break-all hover:text-brand-600"
                >
                  www.adsperianx.com.my
                </a>
              </div>
            </li>
            <li className="flex gap-3">
              <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-brand-600" />
              <div>
                <p className="font-bold text-slate-800">Location</p>
                <p>Malaysia</p>
              </div>
            </li>
          </ul>
        </div>

        <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-8 lg:col-span-3">
          <ContactForm />
        </div>
      </div>
    </div>
  );
}
